<template>
  <img src="@/assets/img/logo-twc.svg" alt="logo">
</template>
<script lang="ts" setup>

</script>
